import { asyncSerializer, Serializer } from '@lib/store';
import { getFareConditionsInitialState } from './get-fare-conditions.reducer';
import { GetFareConditionsState } from './get-fare-conditions.state';

export const getFareConditionsStorageSerializer = asyncSerializer;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFareConditionsStorageDeserializer = (rawObject: any) => {
  return {
    ...getFareConditionsInitialState,
    model: rawObject && rawObject.model ? rawObject.model : null,
  } as GetFareConditionsState;
};

export const getFareConditionsStorageSync: Serializer<GetFareConditionsState> = {
  serialize: getFareConditionsStorageSerializer,
  deserialize: getFareConditionsStorageDeserializer,
};
